import React from "react"
import { View, Text, TouchableOpacity } from "react-native";
import { MaterialIcons } from '@expo/vector-icons';
import BottomSheetButtonProps from "types/components/BottomSheetButton";
import { StyleSheet } from "react-native";
import { colors } from "../../config";

export default ({ 
    fillColor,
    iconName, 
    count, 
    description,
    onPress,
}: BottomSheetButtonProps): JSX.Element => {

    return (
        <TouchableOpacity
            onPress={() => {
                if (onPress) onPress();
            }}
            style={styles.buttonContainer}
        >
            <View style={styles.buttonContent}>
                <MaterialIcons                
                    name={iconName}
                    type="ionicon"
                    color={fillColor}
                    size={25}

                />
                <Text 
                    style={styles.buttonDescription}
                >
                    {description}
                </Text>
            </View>

            {count && <Text style={styles.buttonDescription}>{count}</Text>}
        </TouchableOpacity>  
    )
}

const styles = StyleSheet.create({
    buttonContainer: {
        flexDirection: 'row',
        backgroundColor: '#FFFFFF',
        borderRadius: 10,
        height: 50,
        paddingHorizontal: 20,
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 10,
        borderWidth: 1,
        borderColor: colors.lightGray,
        elevation: 8,
        shadowColor: '#000000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.20,
        shadowRadius: 3.0,
    },
    buttonContent: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
    },
    buttonDescription: {
        fontSize: 16,
        fontWeight: '500',
        marginLeft: 10
    }
});